import { progressActionTypes } from '@constants/actionTypes/commonActionTypes';
import { TICKET_FILE_TYPES, TICKET_MANAGEMENT_TYPES } from '@constants/actionTypes/ticketActionTypes';
import { SPINNER_MESSAGES_IDS } from '@constants/common/miscellaneous';
import API from '@services/API';
import { axiosApi } from '@services/axiosInstance';
import { logError } from '../../../utils/tools/ErrorLoggers';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';

const successStatusCode = 200;

export const addTicket = ticketData => ({
    type: TICKET_MANAGEMENT_TYPES.UPDATE_TICKET,
    ticketData
});

export const setTicketSahInfo = payload => ({
    type: TICKET_MANAGEMENT_TYPES.SET_TICKET_SAH_INFO,
    payload,
});

export const resetTicketSahInfo = () => ({
    type: TICKET_MANAGEMENT_TYPES.RESET_TICKET_SAH_INFO,
});

const isConsumerInfoTransportFailure = data =>
    Boolean(data && data.__consumerInfoRequestFailed === true);

export const isLoading = (value) => {
    return {
        type: value
    };
};

export const isLoaded = (value, data) => {
    return {
        type: value,
        payload:data
    };
};

export const isError = (value, error) => {
    return {
        type: value,
        payload:error
    };
};
/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const getTickets = (url) => async (dispatch, getState) => {
    const data = await API.getData(url, dispatch, actions, true, getState());

    if (data.ticketListJson) {
        return ( data.ticketListJson.filter(obj => obj.number !== undefined) );
    }
};


export const getTicketTypes = (url) => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        return data;
    } else {
        console.error('Cannot getTickets', url);
    }

};

export const getTicketDetail = (url) => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        return data;
    }
};

/************************

 # POST calls

 ************************/



export const createTicket = (...args) => async dispatch => {
    const [url, body, isFileUploadAllowed ] = args;
    const params = isFileUploadAllowed ? [ url, body, 'POST', false, undefined, 'multipart/form-data' ] : [ url, body, undefined, false ];
    const data = await API.postData(params, dispatch, actions);
    if (data) {
        return data;
    } else {
        console.error('Cannot createTickets', url);
    }
};

export const getComments = (...args) => async dispatch => {
    const [url] = args;
    const params = [ url];
    const data = await API.getData(params, dispatch, actions);
    if (data) {
        dispatch(addTicket(data));
        return data;
    } else {
        console.error('Cannot getComments', url);
    }

};

export const postComment = (...args) => async dispatch => {
    const [url, body ] = args;
    const params = [ url, body ];

    const data = await API.postData(params, dispatch, actions);

    if (data) {
        return data;
    } else {
        console.error('Cannot postComment', url);
    }
};


export const getConsumerInformation = (...args) => async dispatch => {
    const [url, oldBody = {}] = args;
    let body = `ticketId=${oldBody.ticketId}`;

    dispatch(resetTicketSahInfo());

    const params = [
        url,
        body,
        'POST',
        true,
        undefined,
        'application/x-www-form-urlencoded',
        true,
        false,
        true,
        undefined,
        true,
    ];

    const data = await API.postData(params, dispatch, actions);

    if (isConsumerInfoTransportFailure(data)) {
        logError('Cannot get Consumer Information (request failed)', url, data);
        return undefined;
    }

    if (data) {
        dispatch(setTicketSahInfo(data));
        return data;
    }

    console.error('Cannot get Consumer Information (empty response)', url);
};

export const postSendMessage = (...args) => async (dispatch) => {
    const [url, oldBody ] = args;
    let body = new FormData();

    Object.keys(oldBody).forEach((key) => {
        body.append(key, oldBody[key]);
    });
    dispatch(startSpinner(SPINNER_MESSAGES_IDS.SAVING_DATA));
    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: 0 });
    return axiosApi.post(
        url, body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent ) => {
                let progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total );
                if (progressPercentage < 100){
                    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: progressPercentage });
                }
            },
            onDownloadProgress: (progressEvent) => {
                let progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total );
                if(!isFinite(progressPercentage)) {
                    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: 100 });
                    return;
                }
                if(!isNaN(progressPercentage)){
                    dispatch({ type: progressActionTypes.FILE_PROCESSING, payload: progressPercentage });
                }
            }
        }
    ).then(response => {
        dispatch(stopSpinner());
        if (response.status === 200 || response.status === 201) {
            window.history.back();
        }
        dispatch({ type: progressActionTypes.FILE_PROCESSED, payload: 0 });
        return response;        
    })
        .catch(() => {
            dispatch(stopSpinner());
            console.error('Cannot post Message', url);
        });
};

export const getAttachments = (...args) => async dispatch => {
    const [url] = args;
    const params = [ url];
    dispatch(isLoading(TICKET_FILE_TYPES.GET_FILE_REQUEST));

    const data = await API.getData(params, dispatch, actions);
    if (data) {
        dispatch(isLoaded(TICKET_FILE_TYPES.GET_FILE_SUCCESS, data));
        return data;
    } else {
        dispatch(isError(TICKET_FILE_TYPES.GET_FILE_ERROR, []));
    }

};

export const postAttachments = (...args) => async dispatch => {
    const [url, body ] = args;
    const params = [ url, body, 'POST', true, undefined , 'multipart/form-data', true];
    
    dispatch(isLoading(TICKET_FILE_TYPES.POST_FILE_REQUEST));

    const data = await API.postData(params, dispatch, actions);
    if (data) {
        dispatch(isLoaded(TICKET_FILE_TYPES.POST_FILE_SUCCESS, true));
        return data;
    } else {
        dispatch(isError(TICKET_FILE_TYPES.POST_FILE_ERROR, true));
    }
};

export const deleteAttachment = (...args) => async dispatch => {
    const [url, body ] = args;
    const params = [ url, body, 'POST', true, undefined , 'multipart/form-data', true, true];
    dispatch(isLoading(TICKET_FILE_TYPES.DELETE_FILE_REQUEST));
    const data = await API.postData(params, dispatch, actions);
    if (data.status === successStatusCode && data.statusText === '') {
        dispatch(isLoaded(TICKET_FILE_TYPES.DELETE_FILE_SUCCESS, true));
    } else {
        dispatch(isError(TICKET_FILE_TYPES.DELETE_FILE_ERROR, true));
    }
};
